import { useCallback, useRef, useState } from 'react';

// Retain the overlay's content while PrimeReact plays its closing transition.
export default function useOverlayState() {
    const [value, setValue] = useState(null);
    const [visible, setVisible] = useState(false);
    const [revision, setRevision] = useState(0);
    const visibleRef = useRef(false);
    const trigger = useRef(null);
    const open = useCallback((next) => {
        trigger.current = next?.trigger || document.activeElement;
        visibleRef.current = true;
        setValue(next);
        setRevision((version) => version + 1);
        setVisible(true);
    }, []);
    const close = useCallback(() => {
        visibleRef.current = false;
        setVisible(false);
    }, []);
    const replace = useCallback((next) => setValue(next), []);
    const onExited = useCallback(() => {
        if (visibleRef.current) return;
        setValue(null);
        // A replacement dialog may already be open (for example, delete confirmation).
        if (!document.querySelector('.p-dialog:not(.p-dialog-exit-done):not(.p-dialog-exit-active), .p-sidebar-active')) trigger.current?.focus?.();
    }, []);
    return { value, visible, revision, open, close, replace, onExited };
}
